"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";

interface CitationButtonProps {
  citation: number;
  onClick: (citation: number) => void;
}

export const CitationButton = memo(function CitationButton({
  citation,
  onClick,
}: CitationButtonProps) {
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(citation);
      }}
      className={cn(
        // Base styles
        "inline-flex items-center justify-center",
        "h-[16px] min-w-[16px] px-[3px]",
        "text-[10px] font-medium",
        "rounded-[2px]",
        "mx-[1px]",
        "transform translate-y-[-2px]",
        "align-top",
        "relative", // For pseudo-element positioning

        // Colors & borders
        "bg-background text-foreground",
        "border border-foreground",

        // Transitions
        "transition-all duration-200 ease-out",

        // Hover underline animation
        "before:content-[''] before:absolute before:bottom-0 before:left-0",
        "before:w-0 before:h-[2px] before:bg-foreground",
        "before:transition-all before:duration-300 before:ease-out",
        "hover:before:w-full",

        // Focus state
        "focus:outline-none focus:ring-1 focus:ring-foreground focus:ring-offset-1 focus:ring-offset-background",

        // Cursor
        "cursor-pointer select-none"
      )}
      title={`Go to source [${citation}]`}
    >
      {citation}
    </button>
  );
});
